const PERSON_DETAIL = 'dofe-bo/persons/PERSON_DETAIL'
const PERSON_DETAIL_SUCCESS = 'dofe-bo/persons/PERSON_DETAIL_SUCCESS'
const PERSON_DETAIL_FAIL = 'dofe-bo/persons/PERSON_DETAIL_FAIL'
const UPDATE_PERSON = 'dofe-bo/persons/UPDATE_PERSON'
const UPDATE_PERSON_SUCCESS = 'dofe-bo/persons/UPDATE_PERSON_SUCCESS'
const UPDATE_PERSON_FAIL = 'dofe-bo/persons/UPDATE_PERSON_FAIL'
const PERSON_LOGIN_CHANGE = 'dofe-bo/persons/PERSON_LOGIN_CHANGE'
const PERSON_LOGIN_CHANGE_SUCCESS =
  'dofe-bo/persons/PERSON_LOGIN_CHANGE_SUCCESS'
const PERSON_LOGIN_CHANGE_FAIL = 'dofe-bo/persons/PERSON_LOGIN_CHANGE_FAIL'
const UPLOAD_PERSON = 'dofe-bo/persons/UPLOAD_PERSON'
const UPLOAD_PERSON_SUCCESS = 'dofe-bo/persons/UPLOAD_PERSON_SUCCESS'
const UPLOAD_PERSON_FAIL = 'dofe-bo/persons/UPLOAD_PERSON_FAIL'
const DELETE_PERSON = 'dofe-bo/persons/DELETE_PERSON'
const DELETE_PERSON_SUCCESS = 'dofe-bo/persons/DELETE_PERSON_SUCCESS'
const DELETE_PERSON_FAIL = 'dofe-bo/persons/DELETE_PERSON_FAIL'
const GET_PERSON_ROLES = 'dofe-bo/persons/GET_PERSON_ROLES'
const GET_PERSON_ROLES_SUCCESS = 'dofe-bo/persons/GET_PERSON_ROLES_SUCCESS'
const GET_PERSON_ROLES_FAIL = 'dofe-bo/persons/GET_PERSON_ROLES_FAIL'
const EDIT_ROLE = 'dofe-bo/persons/EDIT_ROLE'
const EDIT_ROLE_SUCCESS = 'dofe-bo/persons/EDIT_ROLE_SUCCESS'
const EDIT_ROLE_FAIL = 'dofe-bo/persons/EDIT_ROLE_FAIL'
const ADD_ROLE = 'dofe-bo/persons/ADD_ROLE'
const ADD_ROLE_SUCCESS = 'dofe-bo/persons/ADD_ROLE_SUCCESS'
const ADD_ROLE_FAIL = 'dofe-bo/persons/ADD_ROLE_FAIL'

const GET_LOCALES = 'dofe-bo/persons/GET_LOCALES'
const GET_LOCALES_SUCCESS = 'dofe-bo/persons/GET_LOCALES_SUCCESS'
const GET_LOCALES_FAIL = 'dofe-bo/persons/GET_LOCALES_FAIL'

const CHANGE_PERSON_PASS = 'dofe-bo/persons/CHANGE_PERSON_PASS'
const CHANGE_PERSON_PASS_SUCCESS = 'dofe-bo/persons/CHANGE_PERSON_PASS_SUCCESS'
const CHANGE_PERSON_PASS_FAIL = 'dofe-bo/persons/CHANGE_PERSON_PASS_FAIL'

const PERSON_EMAIL_CONFIRM = 'dofe-bo/persons/PERSON_EMAIL_CONFIRM'
const PERSON_EMAIL_CONFIRM_SUCCESS =
  'dofe-bo/persons/PERSON_EMAIL_CONFIRM_SUCCESS'
const PERSON_EMAIL_CONFIRM_FAIL = 'dofe-bo/persons/PERSON_EMAIL_CONFIRM_FAIL'

const CRUD_PERSON = 'dofe-bo/persons/CRUD_PERSON'
const CRUD_PERSON_SUCCESS = 'dofe-bo/persons/CRUD_PERSON_SUCCESS'
const CRUD_PERSON_FAIL = 'dofe-bo/persons/CRUD_PERSON_FAIL'

const REMOVE_ROLE = 'dofe-bo/persons/REMOVE_ROLE'
const REMOVE_ROLE_SUCCESS = 'dofe-bo/persons/REMOVE_ROLE_SUCCESS'
const REMOVE_ROLE_FAIL = 'dofe-bo/persons/REMOVE_ROLE_FAIL'
const REMOVE_DETAIL_DATA = 'dofe-bo/persons/REMOVE_DETAIL_DATA'

const GET_INFO_ROLE = 'dofe-bo/persons/GET_INFO_ROLE'
const GET_INFO_ROLE_SUCCESS = 'dofe-bo/persons/GET_INFO_ROLE_SUCCESS'
const GET_INFO_ROLE_FAIL = 'dofe-bo/persons/GET_INFO_ROLE_FAIL'

const GET_PERSON_USERTYPES = 'dofe-bo/persons/GET_PERSON_USERTYPES'
const GET_PERSON_USERTYPES_SUCCESS =
  'dofe-bo/persons/GET_PERSON_USERTYPES_SUCCESS'
const GET_PERSON_USERTYPES_FAIL = 'dofe-bo/persons/GET_PERSON_USERTYPES_FAIL'

const DEACTIVATE_ACCOUNT = 'dofe-bo/persons/DEACTIVATE_ACCOUNT'
const DEACTIVATE_ACCOUNT_SUCCESS = 'dofe-bo/persons/DEACTIVATE_ACCOUNT_SUCCESS'
const DEACTIVATE_ACCOUNT_FAIL = 'dofe-bo/persons/DEACTIVATE_ACCOUNT_FAIL'

const initialState = {
  detail: {},
  loading: false,
  loaded: false,
  locales: [],
  roles: [],
  roleDetail: {}
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case PERSON_DETAIL:
      return {
        ...state,
        loading: true
      }
    case PERSON_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case PERSON_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case UPLOAD_PERSON:
      return {
        ...state,
        loading: true
      }
    case UPLOAD_PERSON_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case UPLOAD_PERSON_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case UPDATE_PERSON:
      return {
        ...state,
        loading: true
      }
    case UPDATE_PERSON_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case UPDATE_PERSON_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_PERSON_ROLES:
      return {
        ...state,
        loading: true
      }
    case GET_PERSON_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        roles: action.result
      }
    case GET_PERSON_ROLES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_LOCALES:
      return {
        ...state,
        loading: true
      }
    case GET_LOCALES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        locales: action.result
      }
    case GET_LOCALES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case REMOVE_DETAIL_DATA:
      return Object.assign({}, state, {
        detail: {},
        roles: []
      })

    case GET_INFO_ROLE:
      return {
        ...state,
        loading: true
      }
    case GET_INFO_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        roleDetail: action.result
      }
    case GET_INFO_ROLE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case DEACTIVATE_ACCOUNT:
      return {
        ...state,
        loading: true
      }
    case DEACTIVATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        roleDetail: action.result
      }
    case DEACTIVATE_ACCOUNT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}

export function getProfile({ readParams = 'ADDRESS' } = {}) {
  return {
    types: [PERSON_DETAIL, PERSON_DETAIL_SUCCESS, PERSON_DETAIL_FAIL],
    promise: client => client.get(`api/persons/profile?with=${readParams}`)
  }
}

export function updatePerson(id, data, { updateParams } = {}, awardLeaderId = 0) {
  const queryUpdateParams =
    updateParams || 'PERSONAL_DETAILS,LOCALE,CONTACT,ADDRESS'

  return {
    types: [UPDATE_PERSON, UPDATE_PERSON_SUCCESS, UPDATE_PERSON_FAIL],
    promise: client =>
      client.put(`api/persons/${id}?update=${queryUpdateParams}&awardLeaderId=${awardLeaderId}`, {
        data
      })
  }
}

export function deactivateAccount(id, isActive) {
  return {
    types: [DEACTIVATE_ACCOUNT, DEACTIVATE_ACCOUNT_SUCCESS, DEACTIVATE_ACCOUNT_FAIL],
    promise: client =>
      client.post(`api/persons/${id}/deactivate`, {
        data : { isActive }
      })
  }
}



export function changePersonLogin(id, data) {
  return {
    types: [
      PERSON_LOGIN_CHANGE,
      PERSON_LOGIN_CHANGE_SUCCESS,
      PERSON_LOGIN_CHANGE_FAIL
    ],
    promise: client =>
      client.post(`api/persons/${id}/login-change`, {
        data
      })
  }
}

export function uploadPersonImage(id, data) {
  return {
    types: [UPLOAD_PERSON, UPLOAD_PERSON_SUCCESS, UPLOAD_PERSON_FAIL],
    promise: client =>
      client.post(`api/persons/${id}/profilePhoto`, {
        data,
        formData: true
      })
  }
}

export function deletePersonImage(id) {
  return {
    types: [DELETE_PERSON, DELETE_PERSON_SUCCESS, DELETE_PERSON_FAIL],
    promise: client => client.del(`api/persons/${id}/profilePhoto`)
  }
}

export function addPersonRole(id, data) {
  return {
    types: [ADD_ROLE, ADD_ROLE_SUCCESS, ADD_ROLE_FAIL],
    promise: client =>
      client.post(`api/persons/${id}/role-creation`, {
        data
      })
  }
}

export function editPersonRole(id, data) {
  return {
    types: [EDIT_ROLE, EDIT_ROLE_SUCCESS, EDIT_ROLE_FAIL],
    promise: client =>
      client.post(`api/persons/${id}/role-change`, {
        data
      })
  }
}

export function getPersonRoles(id) {
  return {
    types: [GET_PERSON_ROLES, GET_PERSON_ROLES_SUCCESS, GET_PERSON_ROLES_FAIL],
    promise: client => client.get(`api/persons/${id}/roles`)
  }
}

export function changePersonPassword(id, data) {
  return {
    types: [
      CHANGE_PERSON_PASS,
      CHANGE_PERSON_PASS_SUCCESS,
      CHANGE_PERSON_PASS_FAIL
    ],
    promise: client =>
      client.post(`api/persons/${id}/password-change`, {
        data
      })
  }
}

export function getLocales(isTopUser) {
  const url = isTopUser
    ? 'api/translation-locales-system'
    : 'api/translation-locales'

  return {
    types: [GET_LOCALES, GET_LOCALES_SUCCESS, GET_LOCALES_FAIL],
    promise: client => client.get(url)
  }
}

export function removePersonRole(id, data) {
  return {
    types: [REMOVE_ROLE, REMOVE_ROLE_SUCCESS, REMOVE_ROLE_FAIL],
    promise: client =>
      client.post(`api/persons/${id}/role-deletion`, {
        data
      })
  }
}

export function getInfoAboutRole(id, data) {
  return {
    types: [GET_INFO_ROLE, GET_INFO_ROLE_SUCCESS, GET_INFO_ROLE_FAIL],
    promise: client => client.post(`api/persons/${id}/role-info`, { data })
  }
}

export function personEmailConfirmation(personId, awardId, data) {
  return {
    types: [
      PERSON_EMAIL_CONFIRM,
      PERSON_EMAIL_CONFIRM_SUCCESS,
      PERSON_EMAIL_CONFIRM_FAIL
    ],
    promise: client =>
      client.post(
        `api/persons/${personId}/email-confirmation?awardId=${awardId}`,
        {
          data
        }
      )
  }
}

export function getPersonEmailPrefs(personId) {
  return {
    types: [CRUD_PERSON, CRUD_PERSON_SUCCESS, CRUD_PERSON_FAIL],
    promise: client =>
      client.get(`api/testing-emails/email-fields?personId=${personId}`)
  }
}

export function sendPersonEmail(data) {
  return {
    types: [CRUD_PERSON, CRUD_PERSON_SUCCESS, CRUD_PERSON_FAIL],
    promise: client =>
      client.post('api/testing-emails', {
        data
      })
  }
}

export function getPersonUserTypes() {
  return {
    types: [
      GET_PERSON_USERTYPES,
      GET_PERSON_USERTYPES_SUCCESS,
      GET_PERSON_USERTYPES_FAIL
    ],
    promise: client => client.get('api/user-types')
  }
}

export function removeDetailData() {
  return {
    type: REMOVE_DETAIL_DATA
  }
}
